import React, { useState } from "react"

import { buildQuery, compress, useQuery } from "micro-graphql-react"

import classNames from "src/classNames"
import colorGenerator from "src/colorGenerator"

import PieChart from "components/TailoredSectionResultChart"

const TailoredAssignmentOverallResults = ({
  tailoredAssignmentId,
  assignmentName,
  studentName,
}) => {
  const [tag, setTag] = useState({ name: "Overall" })

  const { loaded, data } = useQuery(
    buildQuery(sectionSummariesQuery, {
      tailoredAssignmentId,
      tagId: tag.id,
    })
  )

  const chartData = loaded
    ? data.tailoredAssignment.tailoredSectionSummaries
        .map(tailoredSectionSummary => {
          return {
            sectionId: tailoredSectionSummary.tailoredSection.id,
            sectionName: tailoredSectionSummary.tailoredSection.name,
            label: tag.name,
            averageScore: `${(
              tailoredSectionSummary.averageScore * 100
            ).toFixed(2)}%`,
            completedStudentCount: tailoredSectionSummary.completedStudentCount,
            data: [
              { x: "Correct", y: tailoredSectionSummary.correctCount },
              { x: "Incorrect", y: tailoredSectionSummary.incorrectCount },
              { x: "Skipped", y: tailoredSectionSummary.skippedCount },
            ].filter(d => d.y > 0),
          }
        })
        .filter(d => d.data.length > 0)
    : []

  return (
    <React.Fragment>
      <h3 className="text-center">
        {studentName} Results for {assignmentName}
      </h3>
      <div className="text-center">
        <button
          className="btn bg-blue-500"
          onClick={() => setTag({ name: "Overall" })}
        >
          Overall
        </button>
        {loaded &&
          data.tailoredAssignment.tags.map(tag => (
            <button
              key={tag.id}
              className={classNames(colorGenerator(tag.name), "btn")}
              onClick={() => setTag(tag)}
            >
              {tag.name}
            </button>
          ))}
      </div>
      <div className="row">
        {chartData.map(chartData => (
          <div className="col-md-6 col-sm-12" key={chartData.sectionId}>
            <div className="text-center">
              <h5>
                {chartData.sectionName}
                <br />
                Students completed: {chartData.completedStudentCount}
                <br />
                Average Score: {chartData.averageScore}
              </h5>
              <PieChart chartData={chartData} />
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

const sectionSummariesQuery = compress`
  query($tailoredAssignmentId: ID!, $tagId: ID) {
    tailoredAssignment(id: $tailoredAssignmentId) {
      tags {
        id
        name
      }
      tailoredSectionSummaries(tagId: $tagId) {
        tailoredSection {
          id
          name
        }
        correctCount
        incorrectCount
        skippedCount
        averageScore
        completedStudentCount
      }
    }
  }
`

export default TailoredAssignmentOverallResults
